import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout'
import { addPlanPrice, getPlan } from '../logic/plans/action';

const AddPlansPrice = () => {
    const selector = useSelector(state=>state.plans);
    const [data, setdata] = useState({
      subscription:0,
      month:0,
      price:0,
    })
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
      getPlan(dispatch);
    }, [])

    const addPlanPriceClick = () => {
      addPlanPrice(dispatch,data,navigate)
    }
    return (
      <AppLayout>
          <div className='flex-1 h-full flex flex-col items-center gap-10 p-10 justify-center'>
          <h1>Add New Pricing</h1>
          <div className='w-1/2 flex flex-col items-center gap-4'>
          <select 
          onChange={(ev)=>setdata(prev=>({...prev,subscription:ev.target.value}))}
          value={data.subscription}
    className='h-10 outline-none rounded-md px-4 w-full border-blue-800 border' name="Type" id="Type" >
    <option value={0} disabled selected>Select Plan</option>
    {
      selector.plans?.map(
        (el,i)=><option value={el.id}>{el.name}</option>
      )
    }
  </select>
          <input placeholder='Plan Month' name='month' id='month' value={data.month} onChange={(ev)=>setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}/>
          <input placeholder='Plan Price' name='price' id='price' value={data.price} onChange={(ev)=>setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}/>
          <button onClick={addPlanPriceClick}>ADD Plan Price</button>
          </div>
          </div>
    </AppLayout>
    )
  
}

export default AddPlansPrice
